module.exports = __webpack_public_path__ + "static/img/emailSend.83b605c.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/emailSend.png
// module id = srCV
// module chunks = 1